import { render, staticRenderFns } from "./perfReviewAttachments.vue?vue&type=template&id=fd5b010e&scoped=true"
import script from "./perfReviewAttachments.vue?vue&type=script&lang=js"
export * from "./perfReviewAttachments.vue?vue&type=script&lang=js"
import style0 from "./perfReviewAttachments.vue?vue&type=style&index=0&id=fd5b010e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5b010e",
  null
  
)

export default component.exports